import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useOptionalNotificationDrawer } from '../../shell/NotificationDrawer/NotificationDrawerContext.jsx';

/**
 * Legacy `/notifications` compatibility.
 *
 * The full-page notifications surface has been replaced by a global
 * drawer/sheet mounted in AppShell. External deep links (browser
 * history, saved bookmarks, older push notification payloads) that
 * still point at `/notifications` should not 404 — they should land
 * the customer at the home dashboard with the drawer already open.
 *
 * This route redirects to `/` and, if the drawer context is
 * available (i.e. we're inside AppShell), opens the drawer in an
 * effect so users see the same content instead of an empty home
 * screen. If somehow this component mounts outside the shell,
 * `useOptionalNotificationDrawer` returns a no-op stub — the
 * Navigate still resolves cleanly.
 */
function NotificationsPage() {
  const drawer = useOptionalNotificationDrawer();

  useEffect(() => {
    drawer.open?.();
    // Only fire on mount — subsequent renders shouldn't re-open a
    // panel the user may have just closed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Navigate to="/" replace />;
}

export default NotificationsPage;
